function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#crunchbase-logo_svg__a",
  x: 0.5,
  y: 0.5
});

var _ref2 = /*#__PURE__*/React.createElement("symbol", {
  id: "crunchbase-logo_svg__a",
  overflow: "visible"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64 8c0-4.417-3.583-8-8-8H8C3.583 0 0 3.583 0 8v48c0 4.417 3.583 8 8 8h48c4.417 0 8-3.583 8-8z",
  fill: "#0a4063"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.7 36.725a7.066 7.066 0 11-7.787-9.927 7.06 7.06 0 017.87 4.108h5.477a12.323 12.323 0 00-24.297 2.909 12.33 12.33 0 0024.297 2.91h-5.477zM46.526 21.46h-.904a12.16 12.16 0 00-6.024 2.122V9.862H34.6v35.283h5.025v-1.287a12.323 12.323 0 106.899-22.398zm7.065 13.2v.22a7.01 7.01 0 01-.192.863 6.45 6.45 0 01-.342.9v.1a7.08 7.08 0 01-4.943 3.875l-.67.1h-.15a7.01 7.01 0 01-.767 0 7.153 7.153 0 01-.958-.068h-.22a6.923 6.923 0 01-1.794-.548h-.137a7.09 7.09 0 01-1.588-1.068c-.48-.438-.9-.94-1.246-1.492a7.106 7.106 0 01-.452-.876 7.03 7.03 0 01.082-5.82 7.08 7.08 0 015.668-4.012 6.76 6.76 0 01.726 0 7.08 7.08 0 016.983 6.873 7.06 7.06 0 010 .945z",
  fillRule: "nonzero"
})));

function SvgCrunchbaseLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 66 65",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ref, _ref2);
}

export default SvgCrunchbaseLogo;